import { ASSISTANT_POPUP_SELECTOR } from "../../constants";

export const ASSISTANT_PANEL_DEFAULT_SIZE = { width: 380, height: 490 };

export const ASSISTANT_PANEL_MIN_SIZE = { width: 320, height: 360 };

export const ASSISTANT_PANEL_SIZE_STORAGE_KEY = "assistantPanelSize";

export const ASSISTANT_PANEL_OVERLAY_SELECTOR = `${ASSISTANT_POPUP_SELECTOR}, [role="dialog"]`;
